import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section aria-label="Testimonials" className="bg-transparent" data-id="element-301" data-mp="3ksgyi97eejdg">
      <div className="mx-auto max-w-6xl px-5 py-10" style={{
      paddingTop: "17px",
      paddingBottom: "19px"
    }} data-id="element-302" data-mp="3fycrjpy4ubcd">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-303" data-mp="3b01hbe3xdytm">
          🗣️ Real Field Testimonials
        </h2>
        <div className="mt-8 grid w-full grid-cols-1 gap-5 md:grid-cols-3 md:gap-6" data-id="element-304" data-mp="31zwap66k34gi">
          {testimonials.map((t, i) => <TestimonialCard key={t.name} testimonial={t} delay={i * 0.1} data-id="element-305" data-mp="2x0jqyuazedi5" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}